export const SIDEBAR_DESKTOP_TEST_ID = 'sidebar-desktop';
export const PARENT_SECTION_WRAPPER_TEST_ID = 'parent-section-wrapper';
